import React from "react";

import { cn } from "@/shadcn/lib/utils";

const TITLE_SIZES = {
  sm: "text-sm font-medium",
  base: "text-base font-semibold",
  default: "text-lg font-semibold",
  lg: "text-xl font-semibold",
};

// Adapted from the title row of the @shadcndesign section-header-4 block:
// title and description on the left, actions on the right.
export function SectionHeader({
  title,
  description,
  actions,
  as: Heading = "h2",
  id,
  size = "default",
  className,
  children,
}) {
  return (
    <div
      data-slot="section-header"
      className={cn(
        "flex flex-col justify-between gap-2 md:flex-row md:items-center md:gap-6",
        className
      )}
    >
      <div className="min-w-0 space-y-1">
        <Heading
          id={id}
          className={cn("break-words text-foreground", TITLE_SIZES[size])}
        >
          {title}
        </Heading>
        {description ? (
          <p className="text-sm text-muted-foreground">{description}</p>
        ) : null}
        {children}
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}

export default SectionHeader;
